<template>
  <div class="oi-donation-form" :class="'lang-'+lang">
    <Thanks v-if="step === 'thanks' || page === 'thanks'" />
    <Error v-else-if="step === 'error' || page === 'error'" />
    <div v-else>
      <LanguageSwitcher/>
      <LightFormHeader v-if="header"/>
      <FullForm v-if="page === 'form' && form === 'light'"/>
      <FullExternalForm v-if="page === 'form' && form === 'light-external'"/>
      <BankDetails v-if="page === 'bank'"/>
      <UnsubscribeForm v-if="page === 'unsubscribe'" />
      <ChangeSubscriptionForm v-if="page === 'changeSubscription'" />
      <LightFormFooter v-if="footer" />
      <Overlay v-if="showOverlay" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LanguageSwitcher from '@/components/shared/LanguageSwitcher.vue'
import LightFormHeader from './LightFormHeader.vue'
import LightFormFooter from './LightFormFooter.vue'
import Thanks from '@/components/shared/Thanks.vue'
import Error from '@/components/shared/Error.vue'
import FullForm from '@/components/shared/FullForm.vue'
import FullExternalForm from '@/components/shared/FullExternalForm.vue'
import BankDetails from '@/components/shared/BankDetails.vue'
import ChangeSubscriptionForm from '@/components/change-subscription-form/ChangeSubscriptionForm.vue'
import UnsubscribeForm from '@/components/unsubscribe-form/UnsubscribeForm.vue'
import Overlay from '@/components/shared/Overlay.vue'
import { LABELS } from '@/settings'

export default {
  components: { LightFormFooter, LightFormHeader, FullForm, FullExternalForm, BankDetails, ChangeSubscriptionForm, UnsubscribeForm, LanguageSwitcher, Overlay, Thanks, Error },
  computed: mapState({
    step: state => state.step,
    showOverlay: state => (state.step === 'precheckout' || state.step === 'checkout') && state.checkoutType !== 'popup' && state.checkoutType !== 'widget',
    header: state => state.header,
    footer: state => state.footer,
    page: state => state.page,
    form: state => state.form,
    lang: state => state.language,
    labels: state => LABELS[state.language]
  }),
  methods: {
    changePage: function (page) {
      this.state.page = page
    }
  }
}
</script>

<style scoped>
  .oi-donation-form {
    position: relative;
    padding: 0 10px 10px;
    max-width: 400px;
    background: #fff;
    user-select: none;
  }
  .oi-donation-form input {
    background: #fff;
  }
  .oi-donation-form fieldset input {
    margin-bottom: 10px;
  }
  .oi-donation-form .suggestion {
    position: relative;
    top: -5px;
  }
</style>
